export default __webpack_public_path__ + "static/media/mm.bd16628b.png";